<template>
	<div>
		<div class="d-flex justify-content-end mb-2">
			<DateRangeFilter :from-date.sync="from_date" :to-date.sync="to_date" @change="getData()" />
		</div>

		<DashboardHero
			title="Breeder"
			:subtitle="heroSubtitle"
			snapshot-title="Egg & feed snapshot"
			:hero-stats="heroStats"
			:snapshot-stats="snapshotStats"
			:alerts="alerts"
			@stat-click="breederDetails"
		>
			<template #chart>
				<h3 style="margin-bottom: 4px">Production trend</h3>
				<BreederChartjsLineChart />
			</template>
		</DashboardHero>

		<BirdSalesWidget bird-type="breeder" class="mt-2" @summary="onMarketSummary" />
	</div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
	BCard,
	BCardHeader,
	BCardTitle,
	BCardText,
	BCardBody,
	BRow,
	BCol,
	BMedia,
	BMediaAside,
	BAvatar,
	BMediaBody,
	BCarousel,
	BCarouselSlide,
	BButton,
	BImg,
	BFormDatepicker,
} from "bootstrap-vue";

import BroilerDashboard from "../dashboard/BroilerDashboard.vue";
import BreederChartjsLineChart from "../../charts-and-maps/charts/chartjs/BreederChartjsLineChart.vue";
import DashboardHero from "../components/DashboardHero.vue";
import BirdSalesWidget from "../components/BirdSalesWidget.vue";
import DateRangeFilter from "@core/components/date-range-filter/DateRangeFilter.vue";
import BreederDashboard from "../dashboard/BreederDashboard.vue";
import LayerDashboard from "../dashboard/LayerDashboard.vue";
import VueApexCharts from "vue-apexcharts";
import axiosIns from "@/libs/axios";
import vmson from "@/libs/empty";
import moment from "moment";
import vSelect from "vue-select";

export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardText,
		BCardBody,
		BMedia,
		BAvatar,
		BMediaAside,
		BMediaBody,
		BButton,
		BroilerDashboard,
		BreederDashboard,
		LayerDashboard,
		VueApexCharts,
		BCarousel,
		BCarouselSlide,
		vSelect,
		BImg,
		BFormDatepicker,
		BreederChartjsLineChart,
		DashboardHero,
		BirdSalesWidget,
		DateRangeFilter,
	},
	data: () => {
		return {
			from_date: null,
			to_date: null,
			type: Array,
			slide: null,
			sliding: null,
			info: null,
			marketAlerts: [],
			fromDate: null,
			toDate: null,
			carouselItems: [],
			series: [44],
			search_filter: {
				input_field: "",
				to_date: "",
				from_date: "",
			},
			total_birds: null,
			feed_stock: null,
			ready_to_sale: null,
			chick_placement: null,
			avg_body_weight: null,
			fcr: null,
			mortality_rate: null,
		};
	},
	computed: {
		heroSubtitle() {
			const from = this.from_date || this.fromDate;
			const to = this.to_date || this.toDate;
			return from && to ? `${from} to ${to}` : "";
		},
		heroStats() {
			const info = this.info;
			return [
				{ label: "No of Birds", value: info ? info.total_birds : 0 },
				{ label: "Mortality Rate", value: `${info ? info.mortality_rate : 0}%` },
				{ label: "HDEP", value: `${info ? info.hdep : 0}%` },
				{ label: "HHEP", value: `${info ? info.hhep : 0}%` },
			];
		},
		snapshotStats() {
			const info = this.info;
			return [
				{
					label: "Egg Production",
					value: info ? info.egg_production : 0,
					icon: require("@/assets/images/dashboard/egg_production.svg"),
				},
				{
					label: "Feed Stock",
					value: info ? info.feed_stock : 0,
					icon: require("@/assets/images/dashboard/feed_stock.svg"),
				},
				{
					label: "Hatching Egg",
					value: `${info ? info.hatchingEgg : 0}%`,
					icon: require("@/assets/images/dashboard/hatching_eggs.svg"),
				},
				{
					label: "Sold Egg",
					value: `${info ? info.sold_egg : 0}%`,
					icon: require("@/assets/images/dashboard/sold_egg.svg"),
				},
			];
		},
		alerts() {
			const info = this.info;
			if (!info) return this.marketAlerts || [];
			const list = [];
			const mortality = parseFloat(info.mortality_rate);
			if (!isNaN(mortality)) {
				if (mortality > 5) {
					list.push({ chip: "Mortality", variant: "critical", text: `Mortality rate is ${mortality}%, above the 5% concern threshold.` });
				} else if (mortality > 3) {
					list.push({ chip: "Mortality", variant: "warn", text: `Mortality rate is ${mortality}%, trending high.` });
				}
			}
			return [...list, ...(this.marketAlerts || [])];
		},
	},
	created() {
		this.fromDate = moment().clone().startOf("month").format("YYYY-MM-DD");
		this.toDate = moment().clone().endOf("month").format("YYYY-MM-DD");
		this.getData();
	},
	methods: {
		getSelectedYear(event) {
			this.selected = event;
			this.getGraph();
		},
		onMarketSummary(s) {
			const list = [];
			if (s && s.pending_bids > 0) {
				list.push({ chip: "Bids", variant: "warn", text: `${s.pending_bids} lifter bid${s.pending_bids > 1 ? "s are" : " is"} waiting for your decision.` });
			}
			if (s && s.pending_orders > 0) {
				list.push({ chip: "Orders", variant: "critical", text: `${s.pending_orders} buyer order${s.pending_orders > 1 ? "s need" : " needs"} approval before dispatch.` });
			}
			this.marketAlerts = list;
		},
		breederDetails(type) {
			let farmId = this.$route.params.farmId;
			if (farmId) {
				this.$router.push(`/apps/manage-farm/${farmId}/dashboard/breeder`);
			} else {
				this.$router.push({
					path: `/apps/dashboard/breeder`,
				});
			}
		},

		getData(id) {
			let url = "";
			let farmId = null;
			if (id) {
				farmId = id;
			} else if (this.farmId) {
				farmId = this.farmId;
			}

			if (farmId) {
				if (this.from_date != null && this.to_date != null) {
					url = `web/breeder-data/${farmId}/dashboard?from_date=${this.from_date}&to_date=${this.to_date}`;
				} else {
					url = `web/breeder-data/${farmId}/dashboard?from_date=${this.fromDate}&to_date=${this.toDate}`;
				}
			} else {
				if (this.from_date != null && this.to_date != null) {
					url = `web/breeder-data?from_date=${this.from_date}&to_date=${this.to_date}`;
				} else {
					url = `web/breeder-data?from_date=${this.fromDate}&to_date=${this.toDate}`;
				}
			}
			axiosIns
				.get(url)
				.then((response) => {
					this.info = response.data;
					this.total_birds = response.data.total_birds;
					this.feed_stock = response.data.feed_stock;
					this.ready_to_sale = response.data.ready_to_sale;
					this.chick_placement = response.data.chick_placement;
					this.avg_body_weight = response.data.avg_body_weight;
					this.fcr = response.data.fcr;
					this.mortality_rate = response.data.mortality_rate;
					this.carouselItems = response.data.sliderList;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		getGraph(id) {
			let farmId = id;
			let url = "";
			if (farmId === undefined) {
				farmId = this.$route.params.farmId;
			} else {
				farmId = id;
			}

			if (farmId) {
				url = `web/dashboard-hhed-hhep?year=${this.selected}&farmId=${farmId}`;
			} else {
				url = `web/dashboard-hhed-hhep?year=${this.selected}`;
			}
			this.$http.get(url).then((response) => {
				let hhep = [];
				let hhed = [];
				response.data.forEach((item) => {
					hhep.push(item.hhep);
					hhed.push(Math.floor(item.hhed));
				});
				let dd = this.series.map((item) => {
					if (item.name === "Sales") {
						item.data = hhep;
					} else {
						item.data = hhed;
					}
					return item;
				});
				this.min = Math.min(...dd);
				this.max = Math.max(...dd);
				this.series = [...dd];
			});
		},
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
	},
	mounted() {
		vmson.$on("farmIdEvent", (id) => {});
	},
};
</script>
<style lang="scss">
.mb-25 {
	font-size: 1rem !important;
}
.chart {
	justify-content: center;
}
.card-value {
	align-self: center;
	text-align: center;
}
.carousel-item {
	background: transparent !important;
}
.carousel-item img {
	height: 200px !important ;
}
.carousel-indicators li {
	display: none;
}
.item {
	background: transparent;
	height: 200px;
	width: 600px !important;
	object-fit: contain !important;
	margin-bottom: 1rem;
}
.item.active {
	background: transparent !important;
}
.carousel-control-prev,
.carousel-control-next {
	display: none;
}
.card:hover {
	cursor: pointer;
}
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/pages/hatchery.scss";
@import "@core/scss/vue/pages/_common.scss";
</style>
